define('Components/Comein/js/views/blocks/AuthentificationView',['underscore', 'backbone', 'jquery', 'app', 'ApiRequest',
        'WidgetCollectionView',
        'views/blocks/AuthentificationView',
        'template!Components/Comein/templates/blocks/account/authentification'
    ],

    function (_, Backbone, $, app, ApiRequest,
              WidgetCollectionView,
              AuthentificationView,
              authentificationTemplate
    ) {

        return AuthentificationView.extend({

            events:_.defaults(AuthentificationView.prototype.events,{
                'click .nextstep':'nextStep',
                'click .prevstep':'prevStep',
            }),

            initialize:function(options){
                AuthentificationView.prototype.initialize.apply(this, arguments);
                var view = this;
                view.id_comein = options.id_comein;
                view.phone = options.phone;
                view.email = options.email;
                view.step = 1;
            },

            getTemplate:function(){
                // alias for override
                return authentificationTemplate;
            },

            toggleSteps:function(step){
                // affiche / masque les étapes
                this.$('.step').each(function(){
                    var $step = $(this);
                    if($step.is('.step-'+step)){
                        $step.slideDown();
                    }else{
                        $step.slideUp();
                    }
                });
            },

            registerSuccess:function( customer, apiRoute){
                this.tcTrack('Activation',apiRoute);
            },

            nextStep:function(){
                var view = this,
                    formData = view.parseForm(view.$('.authentification-form')),
                    nextStepButton = view.$('.nextstep'),
                    validateStep = view.validateForm(formData,view.step),
                    step = view.step+1;
                //
                if(validateStep){
                    //
                    switch(step) {
                        // step 2
                        case 2:
                            nextStepButton.addClass('loading').prop('disabled',true);
                            ApiRequest('CustomerNeolaneComein',{
                                id_comein: formData.id_customer_comin,
                                email: formData.email
                            }).done(function (data) {
                                nextStepButton.removeClass('loading').prop('disabled',false);
                                if (data && data.status !== 'success') {
                                    app.banNotice(data.message);
                                } else {
                                    view.step++;
                                    view.$('#preview-email').text(formData.email);
                                    view.$('#preview-comein').text(app.t('n° Come In', 'Account') + ' : ' + formData.id_customer_comin);
                                    view.$('#preview-phone').text(formData.phone);
                                    var userHtml = formData.firstname + ' ' + formData.lastname + '<br>' + formData.birthday;
                                    view.$('#preview-user').html(userHtml);
                                    view.$('.prevstep').addClass('prevstep--visible');
                                    view.toggleSteps(step);
                                }
                            }).fail(function(){
                                nextStepButton.removeClass('loading').prop('disabled',false);
                                app.alert();
                            });

                            break;
                        //
                        // step 3
                        case 3:
                            //
                            view.toggleSubmitLoading(true);
                            view.submitRegisterForm(formData);
                            //
                            return;
                    }

                }
                console.log('nextStep',step,view.step,validateStep);
            },

            success: function (customer) {
                var view = this,
                    comeinSuccessMessageView = new WidgetCollectionView('comeinregistersuccess');
                //
                view.$('#comein-success-widget').append(comeinSuccessMessageView.el);
                view.toggleSteps(3);
                //
                view.unbindSubmitEvent();
                //view.trigger('success', view);
                view.$('button.loading').removeClass('loading').prop("disabled", false);
            },

            prevStep: function () {
                var view = this,
                    step = view.step - 1;

                switch (step) {
                    case 1:
                        view.step--;
                        view.$('#preview-email').text('');
                        view.$('#preview-comein').text('');
                        view.$('#preview-phone').text('');
                        view.$('#preview-user').text('');
                        view.toggleSteps(step);
                        view.$('.prevstep').removeClass('prevstep--visible');
                        break;

                    case 2:

                        break;
                }

            }
        });

    });

